import deepMerge from 'deepmerge';
import cloneDeep from 'lodash/cloneDeep';
import RouteParser from '../Helpers/RouteParser';
import { venueSearchInputOptions } from './venueSearchTypes';

// redux store state 'formPage' initial state. Also represents the shape of its state.
// Note that properties might be wiped, so there are two sets:
// stickyProperties that should not be wiped, and ephemeralProperties that can be wiped

const stickyProperties = {
  eventTypes: [],
  usStates: [],
  summary: {
    isOpen: true,
    mobileDisplay: false,
  },
  referral: {
    facilityName: '',
    sourceCode: '',
    venueCode: '',
    facilityCode: '',
  },
  loggedInUser: null,
};
const ephemeralProperties = {
  maintenanceMode: false,
  venueSelectInputOptions: venueSearchInputOptions,
  currentLocation: '',
  screenWidth: typeof window === 'object' ? window.innerWidth : null,
  formPage: RouteParser.formParts.eventType,
  priceValues: {
    basicCoverageAmount: 0,
    liquor: 0,
    liquorPerDay: 0,
    damageToRentedProperty: 0,
    damageToRentedPropertyPerDay: 0,
    personalProperty: 0,
    cancellation: 0,
    subtotal: 0,
    federalSurcharge: 0,
    stateSurcharge: 0,
    tax: 0,
    total: 0,
  },
  eventType: {
    selection: null,
  },
  formPartOne: {
    complete: false,
  },
  formPartTwo: {
    complete: false,
  },
  summary: {
    excludedCheck: false,
    consentCheck: false,
    height: 0,
    mobileShow: true,
    isLoading: false,
    errorResponse: false,
    additionalCertHolders: [],
    isGettingCertHolders: false,
  },
  eventSelect: {
    valid: false,
    eventTypeSelect: null,
  },
  eventSelectSecondary: {
    valid: false,
    showAlert: false,
    lossClaims: null,
    security: null,
    promoter: null,
  },
  venue: {
    selectedPlaceId: '',
    selectedPlaceAddress: '',
    selectedPlaceAddressComponents: {
      companyName: null,
      address1: null,
      address2: null,
      city: null,
      state: null,
      country: null,
      zip: null,
      addressType: null,
    },
    selectedPlaceUtcOffset: '',
    enabled: false,
    confirmed: false,
    validVenue: false,
    validVenueCode: false,
    validManualAddress: false,
    validVenueAddressAndState: false,
    hasRegionalTax: false,
    taxRegions: [],
    isFederalEntity: true,
    isKentuckyEntity: true,
    isKentuckyCity: true,
    kentuckyCity: '',
    hasLookedUpTax: false,
    venueSearchReadOnly: false,
    venueCodeChecked: false,
    isBlocked: false,
    genericServerError: false,
    venueCode: '',
    manualAddressComponents: {
      companyName: null,
      address1: null,
      city: null,
      state: null,
      country: null,
      zip: null,
    },
    venueCodeReferralOverride: false,
    eventTypes: [],
  },
  basicCoverage: {
    enabled: false,
    confirmed: false,
    valid: false,
    coverage: '1000000',
    glLimit: '',
    options: [],
  },
  aboutEvent: {
    enabled: false,
    confirmed: false,
    valid: false,
  },
  additionalCoverages: {
    enabled: false,
    confirmed: false,
    valid: false,
    personalPropertyStatus: { hide: true, mandatory: false },
    hostLiquorStatus: { hide: true, mandatory: true },
    liquorLiabilityStatus: { hide: false, mandatory: false },
    terrorismStatus: { hide: false, mandatory: true },
    damageToRentedPropertyStatus: { hide: false, mandatory: false },
  },
  insured: {
    enabled: false,
    confirmed: false,
    valid: false,
    insuredRenter: false,
    insuredRenterType: 'Person',
    insuredCompanyType: 'Individual',
    jointVentureType: 'Joint Venture Corporation',
  },
  insuranceContact: {
    enabled: false,
    confirmed: false,
    valid: false,
    contactSame: true,
    contactRenter: false,
  },
  paymentInfo: {
    enabled: false,
    confirmed: false,
    valid: false,
    isLoading: false,
    payeeSame: true,
    payeeRenter: false,
    token: '',
    cardType: '',
    lastFour: '',
    errorMessage: '',
  },
};

const insuredInfoInitialState = {
  insuranceContact: {
    enabled: false,
    confirmed: false,
    valid: false,
    contactSame: true,
    contactRenter: false,
  },
  paymentInfo: {
    enabled: false,
    confirmed: false,
    valid: false,
    isLoading: false,
    payeeSame: true,
    payeeRenter: false,
    token: '',
    cardType: '',
    lastFour: '',
    errorMessage: '',
  },
};

const clone = (o) => cloneDeep(o);

// The whole initial state. Use this for initializing state the very first time
const allInitialState = () =>
  deepMerge(clone(ephemeralProperties), clone(stickyProperties));
// Properties that can be preserved even when wiping formPage
const ephemeralInitialState = () => clone(ephemeralProperties);

export { allInitialState, ephemeralInitialState, insuredInfoInitialState };
